import { render } from "./PackagePurchase.vue?vue&type=template&id=3493881a"
import script from "./PackagePurchase.vue?vue&type=script&lang=js"
export * from "./PackagePurchase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__